import React, { useEffect } from 'react';
import { Calendar, Clock, MapPin, X } from 'lucide-react';
import { formatDate } from '../../utils/formatters';

/**
 * Read-only details of a calendar event.
 */
const EventDetailsDialog = ({ event, isOpen, onClose }) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen || !event) return null;

  const period = event.allDay
    ? 'Dia inteiro'
    : [formatDate(event.startsAt, 'HH:mm'), event.endsAt && formatDate(event.endsAt, 'HH:mm')]
        .filter(Boolean)
        .join(' às ');

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />

      {/* Dialog */}
      <div className="relative bg-white rounded-lg shadow-xl w-full max-w-md mx-4 p-6 outline-none">
        <button
          onClick={onClose}
          aria-label="Fechar"
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="h-5 w-5" />
        </button>

        <div
          className="h-1.5 w-12 rounded-full mb-4"
          style={{ backgroundColor: event.color || '#B47330' }}
        />

        <h3 className="text-lg font-semibold text-gray-900 pr-8">{event.title}</h3>

        <div className="mt-4 space-y-2 text-sm text-gray-600">
          <div className="flex items-center gap-2">
            <Calendar className="h-4 w-4 flex-shrink-0 text-brand-gold" />
            <span className="capitalize">
              {formatDate(event.startsAt, "EEEE, d 'de' MMMM 'de' yyyy")}
            </span>
          </div>

          <div className="flex items-center gap-2">
            <Clock className="h-4 w-4 flex-shrink-0 text-brand-gold" />
            <span>{period}</span>
          </div>

          {event.location && (
            <div className="flex items-center gap-2">
              <MapPin className="h-4 w-4 flex-shrink-0 text-brand-gold" />
              <span>{event.location}</span>
            </div>
          )}
        </div>

        {event.description && (
          <p className="mt-4 text-sm text-gray-700 whitespace-pre-line border-t border-gray-200 pt-4">
            {event.description}
          </p>
        )}
      </div>
    </div>
  );
};

export default EventDetailsDialog;
